import { GetSystemParameterValueByName } from "../../CommonFuntion/SchemaAPICalls";

export async function getCustPoRegexPattern(defaultPattern, store_grp) {
  try {
    const data = await GetSystemParameterValueByName("REACT_APP_CHECKOUT_PO_REGEXSTRING");
    const keyByStore = store_grp ? `regexString_${String(store_grp).trim()}` : null;
    let raw = "";

    // If response is already a plain string, use it.
    if (typeof data === "string") {
      raw = data;
    // If response is an array, prefer store-specific key, else generic key.
    } else if (Array.isArray(data) && data.length > 0) {
      const first = data || {};
      if (keyByStore && first[keyByStore]) {
        raw = first[keyByStore];
      } else if (first.regexString) {
        raw = first.regexString;
      } else {
        // Try any entry that has store-specific key or regexString
        const found =
          (keyByStore && data.find(x => x && x[keyByStore])) ||
          data.find(x => x && x.regexString);
        raw = found ? (keyByStore && found[keyByStore] ? found[keyByStore] : found.regexString) : "";
      }

    // If response is an object, prefer store-specific key, else generic key, else value.
    } else if (data && typeof data === "object") {
      if (keyByStore && data[keyByStore]) {
        raw = data[keyByStore];
      } else if (data.regexString) {
        raw = data.regexString;
      } else if (data.value) {
        raw = data.value;
      }
    }

    // Final fallback to defaultPattern
    raw = (raw || defaultPattern || "").toString().trim();
    return raw || defaultPattern;
  } catch (err) {
    return defaultPattern;
  }
}
